// src/firebase.js
import { initializeApp, getApp, getApps } from "firebase/app";
import { getStorage } from "firebase/storage";

const firebaseStorageConfig = {
  apiKey: "AIzaSyBCGT81AdVFMY-1wxF9aF2lrkzHYtR7Un4",
  authDomain: "voyagevoyage-9d1d2.firebaseapp.com",
  databaseURL:
    "https://voyagevoyage-9d1d2-default-rtdb.europe-west1.firebasedatabase.app",
  projectId: "voyagevoyage-9d1d2",
  storageBucket: "voyagevoyage-9d1d2.appspot.com",
  messagingSenderId: "908694614496",
  appId: "1:908694614496:web:9f4638a4f95cef1fc17b85",
  measurementId: "G-MPHL3YZN6L",
};

const storageApp = !getApps().some((app) => app.name === "storageApp")
  ? initializeApp(firebaseStorageConfig, "storageApp") // Nom personnalisé pour l'app Storage
  : getApp("storageApp"); // Si déjà initialisé, récupère l'instance

const storage = getStorage(storageApp);

export { storage };
